export default {
  init() {
    $('.content-archive-person').on('click', function (event) {
      // do not continue visit the link if the target is social link
      if ($(event.target).closest('a').hasClass('link-social')) {
        return;
      }

      let href = $(this).data('href')
      if (href) {
        window.location.href = href
      }
    });
  },
}
